// extracted by mini-css-extract-plugin
module.exports = {"header-container":"Routes_header-container__3sbLa","notification-container":"Routes_notification-container__2QtXm","content-container":"Routes_content-container__33KIf"};